import { render, staticRenderFns } from "./MiuDesc.vue?vue&type=template&id=3ec3578f&scoped=true"
import script from "./MiuDesc.vue?vue&type=script&lang=js"
export * from "./MiuDesc.vue?vue&type=script&lang=js"
import style0 from "./MiuDesc.vue?vue&type=style&index=0&id=3ec3578f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec3578f",
  null
  
)

export default component.exports